import React from 'react'
import yes from './yes.png'
import { useTranslation } from "react-i18next";
import DynamicTextFormatter from "./DynamicTextFormatter";


export default function Ineligilble() {
  let partnerDetails = JSON.parse(sessionStorage.getItem("partnerDetails"));
  const {t} = useTranslation();

  return (
    <div className="ineligible">
      <div className="ineligibleDetails">
        <div className="ineligibleLogo">
          {/* <div>Not eligible for </div> */}
          <div><DynamicTextFormatter
          textString={t("recommendation.Noteligiblefor")}
          values={{
            __BrandName__: { value:partnerDetails?.title }
          }}/> </div>
          <img alt="" src={partnerDetails?.logoUrl} />
        </div>

        <div className="ineligibleReason">
        {t("recommendation.sorry")}
        </div>
      </div>

      <div className="ineligibleWarning">
        {t("recommendation.thatsokay")}
      </div>
    </div>
  );
}
